/*eslint-disable react/jsx-indent*/
import React, { useContext, useEffect, useState } from 'react';
import styled from 'styled-components';
import moment from 'moment';
import ReactTooltip from 'react-tooltip';
import { useHistory } from 'react-router-dom';
import colors from '../../styles/colors';
import { AppContext } from '../../context/AppContext';
import { Flex } from '../Flex';
import Icon from '../Icon';
import { IconEnum as Icons } from '../Icons';
import * as Time from '../../util/Time';
import Loader from '../Loader';
import * as Price from '../../util/Price';
import Button from '../Button';
import { SEARCH_TYPES } from '../../util/customersUtil';
import TagsList from './TagsList';

const TableBody = styled.tbody``;

const TableWrapper = styled.div`
  width: 100%;
  max-height: 60vh;
  min-height: 60vh;
  overflow: auto;
  &::-webkit-scrollbar {
    width: 10px;
    height: 10px;
  }
  &::-webkit-scrollbar-track {
    box-shadow: inset 0 0 5px grey;
    border-radius: 10px;
  }
  &::-webkit-scrollbar-thumb {
    background: grey;
    border-radius: 10px;
  }
`;

const TableContainer = styled.table`
  border-collapse: collapse;
  background: ${colors.white};
  box-shadow: 0px 4px 16px rgba(0, 0, 0, 0.05);
  box-sizing: border-box;
  border-radius: 0px 10px 10px 0px;
  border: 1px solid ${colors.grey5};
  position: relative;
`;

const TableHeader = styled.thead`
  padding: 7px 25px;
  width: fit-content;
  position: sticky;
  top: -2px;
  background: ${colors.white};
  z-index: 500;
`;

const TableHeaderItem = styled.th`
  text-align: left;
  font-size: 1rem;
  color: ${colors.grey3};
  min-width: 210px;
  &:first-child {
    position: sticky;
    top: -2px;
    left: -1px;
    background: ${colors.white};
    z-index: 500;
  }
`;

const TableRow = styled.tr`
  border-bottom: 1px solid ${colors.grey5};
  width: fit-content;
  transition: all 0.1s;
  align-items: center;
  &:hover {
    background: rgba(211, 211, 211, 0.1);
  }
`;

const CheckBox = styled.input`
  cursor: pointer;
`;

const TableRowItem = styled.td`
  border-right: 1px solid ${colors.grey5};
  font-size: 1.4rem;
  color: ${colors.grey1};
  padding: 0 20px;
  background: white;
  color: ${(props) => (props.onClick ? colors.seaGreen : null)};
  cursor: ${(props) => (props.onClick ? 'pointer' : null)};
  &:first-child {
    height: 100%;
    position: sticky;
    left: -1px;
    z-index: 400;
    padding: 0 20px;
    box-shadow: inset -7px 0 1px -7px rgba(0, 0, 0, 0.4);
    border-right: unset;
  }
`;

const NoContentContainer = styled.div`
  height: ${(props) => props.height || '60vh'};
  display: flex;
  flex-direction: ${(props) => props.direction || 'column'};
  align-items: center;
  justify-content: center;
  background-color: #fff;
  box-shadow: 0px 4px 16px rgba(0, 0, 0, 0.05);
  width: 100%;
  border-bottom: 1px solid ${colors.grey5};
`;

const NoContentHeader = styled.div`
  font-weight: 600;
  font-size: 1.4rem;
  color: ${colors.grey1};
  margin-bottom: 10px;
`;

const NoContentText = styled.div`
  font-weight: 500;
  font-size: 1.2rem;
  color: ${colors.grey3};
`;

const LoaderContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 2000;
`;

const NoContentBody = styled.div`
  width: 100%;
  text-align: center;
  position: relative;
`;
const WelcomeHeader = styled.div`
  display: flex;
  align-items: center;
  height: 45px;
  border-right: 1px solid ${colors.grey5};
  border-bottom: 1px solid ${colors.grey5};
  padding: 0 20px;
`;

const IconContainer = styled.div`
  margin-left: 10px;
  cursor: pointer;
`;

const QueryContent = styled.div`
  position: ${(props) => (props.top ? 'sticky' : null)};
  top: ${(props) => (props.top ? '0' : null)};
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: ${(props) => props.direction || 'column'};
`;

const QueryText = styled.h4`
  width: ${(props) => props.textWidth || null};
  margin: 10px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const NoContent = ({
  contacts,
  searchQuery,
  setSearchQuery,
  height,
  direction,
  textWidth,
}) => {
  const refetchWithoutQuery = () => {
    setSearchQuery({ type: SEARCH_TYPES.Clear });
  };

  return (
    <NoContentContainer height={height}>
      {(searchQuery?.phoneNumber || searchQuery?.tags)
      && contacts.length > 0 ? (
          <NoContentBody>
            <QueryContent top="1" direction={direction}>
              {searchQuery?.phoneNumber && contacts.length && (
                <QueryText textWidth={textWidth}>
                Displaying search results for {`"${searchQuery.phoneNumber}"`}
                </QueryText>
              )}
              {searchQuery?.tags && contacts.length && (
                <QueryText textWidth={textWidth}>
                Displaying contacts with tags :
                  {`${searchQuery.tags.map((item) => {
                    return ` ${ item } `;
                  })} `}
                </QueryText>
              )}

              <Button
                type="button"
                text="Clear filter"
                onClick={() => refetchWithoutQuery()}
                width="max-content"
                margin="5px"
                height="25px"
              />
            </QueryContent>
          </NoContentBody>
        ) : (
          <NoContentBody>
            {searchQuery?.phoneNumber || searchQuery?.tags ? (
              <QueryContent direction={direction}>
                {searchQuery?.phoneNumber && (
                  <QueryText textWidth={textWidth}>
                  No contacts found for {`${searchQuery?.phoneNumber}`}
                  </QueryText>
                )}
                {searchQuery?.tags && (
                  <QueryText textWidth={textWidth}>
                  No contacts found with tags :{' '}
                    {`${searchQuery.tags.map((item) => {
                      return ` ${ item } `;
                    })}`}
                  </QueryText>
                )}
                <Button
                  type="button"
                  text="Clear filter"
                  onClick={() => refetchWithoutQuery()}
                  width="max-content"
                  margin="5px"
                  height="25px"
                />
              </QueryContent>
            ) : (
              <>
                {contacts?.length < 1 && (
                  <>
                    <NoContentHeader>No Contacts yet</NoContentHeader>
                    <NoContentText>
                    Import contact phone numbers by clicking the button above
                    </NoContentText>
                  </>
                )}
              </>
            )}
          </NoContentBody>
        )}
    </NoContentContainer>
  );
};
const TableHeaderCompnent = ({ ordering, ...props }) => {
  const { fieldName, order } = ordering;
  let orderingIcon = (
    <Icon
      icon={Icons.Sort}
      size={12}
      margin="5px"
      active
      activeColor={colors.grey3}
    />
  );

  if (fieldName === props.columnName && order === 'asc') {
    orderingIcon = (
      <Icon
        margin="5px"
        icon={Icons.SortUp}
        size={12}
        active
        activeColor={colors.grey3}
      />
    );
  } else if (fieldName === props.columnName && order === 'desc') {
    orderingIcon = (
      <Icon
        margin="5px"
        icon={Icons.SortDown}
        size={12}
        active
        activeColor={colors.grey3}
      />
    );
  }

  return (
    <TableHeaderItem
      onClick={() => (props?.handleSort ? props.handleSort(props.columnName) : null)}
    >
      <div
        style={{
          cursor: props?.handleSort ? 'pointer' : null,
          display: 'flex',
          alignItems: 'center',
          height: '45px',
          borderRight: `1px solid ${colors.grey5}`,
          borderBottom: `1px solid ${colors.grey5}`,
          padding: '0 20px',
        }}
      >
        {props.children} {props?.handleSort ? orderingIcon : null}
      </div>
    </TableHeaderItem>
  );
};

export default function CustomerTable({
  contacts,
  fetchMore,
  refFetchMore,
  ordering,
  handleSort,
  isMore,
  loadMoreData,
  getRefferedContactsClick,
  fetching,
  setFetching,
  searchQuery,
  setSearchQuery,
  scrollToTop,
  referralMarketingEnabled = true,
  smsCampaignsEnabled = false,
}) {
  const { app, setApp } = useContext(AppContext);
  const [recentlyUploadedNumbers, setRecentlyUploadedNumbers] = useState(null);
  const [checked, setChecked] = useState(false);
  const history = useHistory();

  const onDetailClick = (phoneNumber) => {
    history.push(`/customers/${phoneNumber}`);
  };

  useEffect(() => {
    const numbers = contacts
      .filter((contact) => {
        return (
          Time.getStartOfDay(Time.now()) < contact.lastImported
          && contact.attendedOrganization
        );
      })
      .map((contact) => {
        return contact.phoneNumber;
      });
    setRecentlyUploadedNumbers(numbers);
  }, [contacts]);
  const scrollContainer = React.useRef();

  const handleScroll = () => {
    if (fetchMore === false || refFetchMore === false) return;
    if (scrollContainer?.current.scrollTop > 0) {
      const scrollPosition = scrollContainer?.current.offsetHeight
        + scrollContainer?.current.scrollTop;
      const scrollPositionMax = scrollContainer?.current.scrollHeight - 300;
      if (
        scrollPosition >= scrollPositionMax
        && !fetching
        && isMore !== false
      ) {
        setFetching(true);
        setTimeout(() => {
          loadMoreData();
          setFetching(false);
        }, 0);
      }
    }
  };

  // The check box stuff is kind of a mess, sorry.
  // The deliverable kept changing.

  useEffect(() => {
    if (scrollContainer?.current) {
      scrollContainer.current.scrollTop = 0;
    }
  }, [scrollToTop]);

  return (
    <>
      {(searchQuery?.phoneNumber || searchQuery?.tags?.length)
        && contacts.length > 0 && (
        <NoContent
          contacts={contacts}
          setSearchQuery={setSearchQuery}
          searchQuery={searchQuery}
          height="fit-content"
          direction="row"
        />
      )}
      <TableWrapper ref={scrollContainer} onScroll={handleScroll}>
        {fetching && (
          <LoaderContainer>
            <Loader />
          </LoaderContainer>
        )}

        {contacts?.length || fetching ? (
          <>
            <TableContainer>
              <TableHeader>
                <tr>
                  <TableHeaderCompnent
                    ordering={ordering}
                    handleSort={handleSort}
                    columnName="phoneNumber"
                  >
                    PHONE
                  </TableHeaderCompnent>
                  <TableHeaderCompnent
                    ordering={ordering}
                    // handleSort={handleSort}
                    columnName="createdAt"
                  >
                    Tags
                  </TableHeaderCompnent>
                  <TableHeaderCompnent
                    ordering={ordering}
                    handleSort={handleSort}
                    columnName="createdAt"
                  >
                    CREATED AT
                  </TableHeaderCompnent>
                  <TableHeaderCompnent
                    ordering={ordering}
                    handleSort={handleSort}
                    columnName="lastImported"
                  >
                    LAST IMPORT
                  </TableHeaderCompnent>
                  {referralMarketingEnabled && (
                    <>
                      <TableHeaderItem>
                        <WelcomeHeader
                          // padding="20px"
                          height="45px"
                          align="center"
                          border={`1px solid ${colors.grey5}`}
                        >
                          <CheckBox
                            type="checkbox"
                            data-tip="Select all contacts imported today"
                            checked={checked}
                            onChange={() => {
                              if (checked) {
                                setChecked(false);
                                setApp({
                                  ...app,
                                  welcomeQueue: [],
                                  sendAllWelcomes: false,
                                });
                              } else {
                                setChecked(true);
                                setApp({
                                  ...app,
                                  welcomeQueue: [],
                                  sendAllWelcomes: true,
                                });
                              }
                            }}
                          />
                          <div style={{ marginLeft: '10px' }}>IN WELCOME QUEUE</div>
                        </WelcomeHeader>
                      </TableHeaderItem>
                      <TableHeaderCompnent
                        ordering={ordering}
                        handleSort={handleSort}
                        columnName="currentAvailableBalance"
                      >
                        CURRENT AVAILABLE BALANCE
                      </TableHeaderCompnent>
                      <TableHeaderCompnent
                        ordering={ordering}
                        handleSort={handleSort}
                        columnName="totalCreditGranted"
                      >
                        TOTAL CREDIT GRANTED
                      </TableHeaderCompnent>
                      <TableHeaderCompnent
                        ordering={ordering}
                        handleSort={handleSort}
                        columnName="totalCreditRedeemed"
                      >
                        TOTAL CREDIT REDEEMED
                      </TableHeaderCompnent>
                      <TableHeaderCompnent
                        ordering={ordering}
                        handleSort={handleSort}
                        columnName="totalCouponsGranted"
                      >
                        TOTAL DISCOUNTS GRANTED
                      </TableHeaderCompnent>
                      <TableHeaderCompnent
                        ordering={ordering}
                        handleSort={handleSort}
                        columnName="totalCouponsRedeemed"
                      >
                        TOTAL DISCOUNTS REDEEMED
                      </TableHeaderCompnent>
                      <TableHeaderCompnent
                        ordering={ordering}
                        handleSort={handleSort}
                        columnName="totalCouponsAcceptedRef"
                      >
                        TOTAL REF DISCOUNTS ACCEPTED
                      </TableHeaderCompnent>
                      <TableHeaderCompnent
                        ordering={ordering}
                        handleSort={handleSort}
                        columnName="totalRefClicks"
                      >
                        TOTAL REF CLICKS
                      </TableHeaderCompnent>
                      <TableHeaderCompnent
                        ordering={ordering}
                        handleSort={handleSort}
                        columnName="totalCouponsRedRef"
                      >
                        TOTAL REF DISCOUNTS REDEEMED
                      </TableHeaderCompnent>
                      <TableHeaderCompnent
                        ordering={ordering}
                        handleSort={handleSort}
                        columnName="totalConversionRateRef"
                      >
                        TOTAL REF CONVERSION RATE
                      </TableHeaderCompnent>
                    </>
                  )}
                  <TableHeaderCompnent
                    ordering={ordering}
                    handleSort={handleSort}
                    columnName="originalSource"
                  >
                    ORIGINAL SOURCE
                  </TableHeaderCompnent>
                  <TableHeaderCompnent
                    ordering={ordering}
                    handleSort={handleSort}
                    columnName="optInMethod"
                  >
                    OPT-IN METHOD
                  </TableHeaderCompnent>
                  <TableHeaderCompnent
                    ordering={ordering}
                    handleSort={handleSort}
                    columnName="lastOptIn"
                  >
                    LAST OPT-IN
                  </TableHeaderCompnent>
                  <TableHeaderCompnent
                    ordering={ordering}
                    handleSort={handleSort}
                    columnName="optOut"
                  >
                    OPT-OUT
                  </TableHeaderCompnent>
                  {smsCampaignsEnabled && (
                    <TableHeaderCompnent
                      ordering={ordering}
                      handleSort={handleSort}
                      columnName="smsCampaignOptOut"
                    >
                      SMS OPT-OUT
                    </TableHeaderCompnent>
                  )}
                </tr>
              </TableHeader>
              <TableBody>
                {contacts.map((contact) => {
                  const hasBeenWelcomed = contact.welcomed > Time.now() - Time.DAY * 7;

                  const refAcceptedClickable = (contact.totalCouponsAcceptedRef > 0 && !fetching) || false;

                  const redeemClickable = (contact.totalCouponsRedRef > 0 && !fetching) || false;

                  return (
                    <TableRow
                      key={contact._id}
                      onClick={() => setApp({
                        ...app,
                        customerInfoContext: contact.phoneNumber,
                      })}
                    >
                      <TableRowItem>
                        <Flex>
                          <div data-tip="View Transactions">
                            <Icon
                              icon={Icons.Binoculars}
                              size={12}
                              margin="2px 5px 0 0"
                              onClick={() => onDetailClick(contact.phoneNumber)}
                            />
                          </div>
                          <div>{contact.phoneNumber}</div>
                          <IconContainer
                            data-tip={
                              hasBeenWelcomed
                                ? `This user has been sent a welcome text within the last 7 days and cannot be sent another until ${moment(
                                  (contact.welcomed + Time.DAY * 7) * 1000,
                                ).format('L h:mma')}`
                                : 'This user has not been sent a welcome text within the last 7 days. Send one now!'
                            }
                          >
                            <Icon
                              icon={Icons.CheckCircleSolid}
                              size={12}
                              active
                              activeColor={
                                hasBeenWelcomed ? colors.seaGreen : colors.grey3
                              }
                            />
                          </IconContainer>
                        </Flex>
                      </TableRowItem>
                      <TableRowItem>
                        <TagsList
                          phoneNumber={contact.phoneNumber}
                          attachedTags={contact.attachedTags}
                          searchQuery={searchQuery}
                          setSearchQuery={setSearchQuery}
                        />
                      </TableRowItem>
                      <TableRowItem>
                        {moment(contact.createdAt * 1000).format('L')}
                      </TableRowItem>
                      <TableRowItem>
                        {moment(contact.lastImported * 1000).format('L')}
                      </TableRowItem>
                      {referralMarketingEnabled && (
                        <>
                          <TableRowItem>
                            <CheckBox
                              type="checkbox"
                              data-tip={
                                checked
                                  ? 'Unselect the top check box to create a custom welcome text list'
                                  : ''
                              }
                              checked={
                                !!app?.welcomeQueue?.includes(
                                  contact.phoneNumber,
                                )
                                || (checked
                                  && recentlyUploadedNumbers.includes(
                                    contact.phoneNumber,
                                  ))
                              }
                              onChange={() => {
                                // currently only allow you to select the recent imports or select manually, not both
                                if (!checked) {
                                  if (!app?.welcomeQueue) {
                                    setApp({
                                      ...app,
                                      welcomeQueue: [contact.phoneNumber],
                                    });
                                  } else if (
                                    app.welcomeQueue.includes(contact.phoneNumber)
                                  ) {
                                    const newArr = [...app.welcomeQueue];
                                    const filtered = newArr.filter(
                                      (e) => e !== contact.phoneNumber,
                                    );
                                    setApp({ ...app, welcomeQueue: filtered });
                                  } else {
                                    const newArr = [...app.welcomeQueue];
                                    newArr.push(contact.phoneNumber);
                                    setApp({ ...app, welcomeQueue: newArr });
                                  }
                                }
                              }}
                            />
                          </TableRowItem>
                          <TableRowItem>
                            {`$${Price.output(
                              contact.currentAvailableBalance,
                              true,
                            )}`}
                          </TableRowItem>
                          <TableRowItem>
                            {`$${Price.output(contact.totalCreditGranted, true)}`}
                          </TableRowItem>
                          <TableRowItem>
                            {`$${Price.output(contact.totalCreditRedeemed, true)}`}
                          </TableRowItem>
                          <TableRowItem>{contact.totalCouponsGranted}</TableRowItem>
                          <TableRowItem>
                            {contact.totalCouponsRedeemed}
                          </TableRowItem>
                          <TableRowItem
                            onClick={
                              refAcceptedClickable
                                ? () => getRefferedContactsClick({
                                  phoneNumber: contact.phoneNumber,
                                  couponType: 'accepted',
                                  _id: contact._id,
                                })
                                : null
                            }
                          >
                            {`$${Price.output(
                              contact.totalCouponsAcceptedRef,
                              true,
                            )}`}
                          </TableRowItem>
                          <TableRowItem>
                            {contact.totalRefClicks || '0'}
                          </TableRowItem>
                          <TableRowItem
                            onClick={
                              redeemClickable
                                ? () => getRefferedContactsClick({
                                  phoneNumber: contact.phoneNumber,
                                  couponType: 'redeemed',
                                  _id: contact._id,
                                })
                                : null
                            }
                          >
                            {`$${Price.output(contact.totalCouponsRedRef, true)}`}
                          </TableRowItem>
                          <TableRowItem>
                            {contact.totalConversionRateRef}%
                          </TableRowItem>
                        </>
                      )}
                      <TableRowItem>{contact.originalSource}</TableRowItem>
                      <TableRowItem>{contact.optInMethod}</TableRowItem>
                      <TableRowItem>
                        {contact.lastOptIn
                          ? moment(contact.lastOptIn * 1000).format('L')
                          : ''}
                      </TableRowItem>
                      <TableRowItem>
                        {contact.optOut
                          ? moment(contact.optOut * 1000).format('L')
                          : ''}
                      </TableRowItem>
                      {smsCampaignsEnabled && (
                        <TableRowItem>
                          {contact.smsCampaignOptOut
                            ? moment(contact.smsCampaignOptOut * 1000).format('L')
                            : ''}
                        </TableRowItem>
                      )}
                    </TableRow>
                  );
                })}
              </TableBody>
            </TableContainer>
            <ReactTooltip place="right" type="dark" effect="solid" />
          </>
        ) : (
          <NoContent
            searchQuery={searchQuery}
            setSearchQuery={setSearchQuery}
            contacts={contacts}
          />
        )}
      </TableWrapper>
    </>
  );
}

export { NoContent };
